module.exports = __webpack_public_path__ + "static/media/Takeaway_coffee_credit_Getty_Images_mobile.cd4ca56b.jpg";